import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-329c1a51"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mac" }
const _hoisted_2 = { class: "mac__modal" }
const _hoisted_3 = { class: "mac__modal-close" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mac__modal-title" }, "Активация каналов", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mac__modal-channels" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mac__modal-channels-label1" }, "Каналов доступно"),
  /*#__PURE__*/_createElementVNode("div", { class: "mac__modal-channels-label2" }, "100 из 100")
], -1))
const _hoisted_6 = { class: "mac__modal-wrap" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mac__modal-wrap-label" }, " Количество каналов для активации ", -1))
const _hoisted_8 = {
  key: 2,
  class: "mac__modal-wrap-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconClose = _resolveComponent("IconClose")!
  const _component_UiNumberSelect = _resolveComponent("UiNumberSelect")!
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
      class: "mac__overlay"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_IconClose, {
          onClick: _ctx.onClose,
          class: "mac__modal-close-icon"
        }, null, 8, ["onClick"])
      ]),
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_UiNumberSelect, {
          class: "mac__modal-wrap-select",
          "default-value": _ctx.DEFAULT_CHANNELS,
          total: 50,
          onSelectedValue: _ctx.onSelectedValue,
          "is-disable": _ctx.isDisable
        }, null, 8, ["default-value", "onSelectedValue", "is-disable"]),
        (!_ctx.isDisable)
          ? (_openBlock(), _createBlock(_component_UiButton, {
              key: 0,
              onClick: _ctx.onClickCreateInstance,
              class: "mac__modal-wrap-button",
              label: "Активировать",
              "background-color": "var(--theme-color)",
              "border-color": "var(--theme-color)",
              color: "rgb(255, 255, 255)",
              "font-weight": "600",
              "font-size": "16px"
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isDisable)
          ? (_openBlock(), _createBlock(_component_UiButton, {
              key: 1,
              disable: _ctx.isDisable,
              class: "mac__modal-wrap-button",
              label: "Активировать",
              "background-color": "#c5c5c5",
              "border-color": "#c5c5c5",
              color: "rgb(255, 255, 255)",
              "font-weight": "600",
              "font-size": "16px"
            }, null, 8, ["disable"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
          class: "mac__modal-wrap-cancel"
        }, " Отмена "),
        (_ctx.isError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Ошибка: " + _toDisplayString(_ctx.errorMessage), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}